import { Component, effect, inject } from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { QrCodeComponent } from 'ng-qrcode';

@Component({
  selector: 'afcu-kiosk-side',
  standalone: true,
  imports: [QrCodeComponent],
  templateUrl: './kiosk-side.component.html',
  styleUrl: './kiosk-side.component.css'
})
export class KioskSideComponent extends BaseConfigurableComponent{
  protected schedulerService = inject( SchedulerStepService );

  token = this.generateToken()

  constructor(){
    super('page')

    setInterval(() => {
      this.token = this.generateToken()
    }, this.schedulerService.settings().GLOBAL.kiosk_allow_device.value*60*1000) 
  }

  generateToken() {
    return `&token=${new Date().getTime()+this.schedulerService.settings().GLOBAL.kiosk_allow_device.value*60*1000}`
  }

  get linkQR() {
    return window.location.href + this.token
  }
}
